import { type FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'
import {
  MenuBase,
  MenuItem,
  MenuHeader,
  Divider,
  NavigationBar,
} from '@retailer-platform/shared-components/src/tds'
import { ChevronDownIcon, ChevronUpIcon } from '@instacart/ids-core'
import { AccountManagementMyAccountModal } from '@retailer-platform/domain-account-management'
import { useAdminControls } from '../../../utils/contexts/admin-controls/AdminControlsContext'
import { useCurrentAccountContext } from '../../../utils/current-account/CurrentAccountContext'
import useAccessControl from '../../../legacy/components/AccessControl/useAccessControl'
import { Permission } from '../../../legacy/common/types'
import { URL_LOGOUT } from '../../../utils/routing/routes'
import { AdminControlModal } from '../admin-controls-modal/AdminControlsModal'
import { useTopBarMenu } from './TopBarMenuContext'

const CHEVRON_SIZE = 16

export const TdsUserMenu: FunctionComponent = () => {
  const intl = useIntl()
  const { isOpen, setIsOpen } = useTopBarMenu('user')
  const [showManageAccount, setShowManageAccount] = useState(false)
  const { openAdminControls } = useAdminControls()
  const { account } = useCurrentAccountContext()
  const hasAccess = useAccessControl()
  const isInternalAdmin = hasAccess({ permissions: Permission.AdminPanel })

  const Chevron = isOpen ? ChevronUpIcon : ChevronDownIcon

  const trigger = (
    <NavigationBar.Button
      aria-label={intl.formatMessage({ id: 'app.nav.userMenu.label' })}
      icon="profile"
      trailingIcon={<Chevron size={CHEVRON_SIZE} fill="currentColor" />}
      onPress={() => setIsOpen(!isOpen)}
    />
  )

  return (
    <>
      <MenuBase target={trigger} isOpen={isOpen} onMenuStateChange={setIsOpen} position="bottomEnd">
        <MenuHeader title={account.givenName} />
        <MenuItem text={account.email} disabled />
        <Divider />
        <MenuItem
          text={intl.formatMessage({ id: 'navV2.userSettings.manageAccount' })}
          onClick={() => {
            setIsOpen(false)
            setShowManageAccount(true)
          }}
        />
        {isInternalAdmin && (
          <MenuItem
            text={intl.formatMessage({ id: 'app.admin.nav.links.adminControls' })}
            onClick={() => {
              setIsOpen(false)
              openAdminControls()
            }}
          />
        )}
        <MenuItem text={intl.formatMessage({ id: 'logout' })} href={URL_LOGOUT} />
      </MenuBase>
      <AccountManagementMyAccountModal
        isOpen={showManageAccount}
        onClose={() => setShowManageAccount(false)}
      />
      {isInternalAdmin && <AdminControlModal />}
    </>
  )
}
